export default {
    get(key, defaultValue) {
        return JSON.parse(localStorage.getItem(key)) ?? defaultValue;
    },
    put(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    remove(key) {
        localStorage.removeItem(key);
    },
};
